<template>
    <div class="mt-2">
        <div id="personTable">
            <v-toolbar
                class="elevation-1 white--text"
                color="primary"
                height="50px"
            >
                <v-toolbar-title>
                    <v-icon class="white--text">fa-briefcase</v-icon>
                    Jobs
                </v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                />
                <v-spacer />
                <EditJobDialog />
                <AddJobDialog :job-id="jobId" />
            </v-toolbar>
            <v-data-table
                :headers="jobTableHeaders"
                :items="jobListForTable"
                class="elevation-1"
                v-if="jobListForTable !== undefined"
            >
                <template
                    slot="item"
                    slot-scope="props"
                >
                    <tr>
                        <td class="text-xs-left">
                            <!--              <router-link-->
                            <!--                :to="{ name: 'manage job', params: { jobId: props.item.jobId }}"-->
                            <!--                class="manageJobLink"-->
                            <!--              >-->{{ props.item.name }}
                            <!--              </router-link>-->
                        </td>
                        <td
                            class="d-sm-table-cell text-xs-left"
                            v-if="props.item.personnelCount != undefined"
                        >
                            {{ props.item.personnelCount }}
                        </td>
                        <td
                            class="justify-center layout px-0"
                        >
                            <v-icon
                                @click="editItem(props.item)"
                                class="mr-2"
                                small
                                style="display: inline-flex;"
                            >
                                edit
                            </v-icon>
                            <!--              <v-icon-->
                            <!--                @click="deleteItem(props.item)"-->
                            <!--                small-->
                            <!--                style="display: inline-flex;"-->
                            <!--              >-->
                            <!--                delete-->
                            <!--              </v-icon>-->
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import {FETCH_JOB_LIST} from "@/store/job/actions.js";
    import {LOAD_JOB_TO_EDIT, TOGGLE_EDIT_JOB_DIALOG} from "@/store/job/mutations.js"
    import {FETCH_PERSONNEL,} from "@/store/person/actions.js";
    import {FETCH_PERSONNEL_EMPLOYMENT_LIST} from "@/store/person_employment/actions.js"
    import EditTableFunctions from './../../ManagePersonnel/components/editTableFunctions';
    import AddJobDialog from "./AddJobDialog";
    import EditJobDialog from "./EditJobDialog";

    export default {

        components: {
            AddJobDialog,
            EditJobDialog,
        },

        mixins: [
            EditTableFunctions,
        ],

        data() {
            return {
                breadcrumbPath: [{text: process.env.VUE_APP_SYSTEM_NAME, to: "/"}, {text: 'Manage Jobs', disabled: true,}],
                loading: true,
                personnelWithJobTitle: [],
                selectedPersonnelId: '',
                jobId: '',
                idName: 'jobId',
                chosenPerson: {},
                jobTableHeaders: [
                    {
                        text: 'Name',
                        align: 'left',
                        value: 'name',

                    },
                    {text: 'Staff Count', value: 'personnelCount'},
                    {text: 'Actions', value: 'name', sortable: false}
                ],
                editedId: -1,
            };
        },

        computed: {
            ...mapGetters(
            [
                "jobListForTable",
            ]
            )
        },

        mounted() {
            this.fetchPersonnel();
            this.fetchPersonnelEmployments();
            this.fetchJobs();

            if (
            this.$route.params !== undefined
            && this.$route.params.jobId !== undefined) {
                this.jobId = this.$route.params.jobId;

            }
        },


        methods: {
            fetchPersonnel() {
                this.$store.dispatch(FETCH_PERSONNEL);
            },
            fetchPersonnelEmployments() {
                this.$store.dispatch(FETCH_PERSONNEL_EMPLOYMENT_LIST);
            },
            fetchJobs() {
                this.$store.dispatch(FETCH_JOB_LIST);
            },

            // resetTable() {
            //     this.$store.commit(RESET_DEFAULT_NEW_JOB_LIST);
            // },
            ...mapActions({
                fetchTableList: FETCH_JOB_LIST,
            }),

            ...mapMutations({
                toggleEditDialog: TOGGLE_EDIT_JOB_DIALOG,
                loadTableItemToEdit: LOAD_JOB_TO_EDIT,
            })
        },
    }
</script>

<style scoped>
    #jobTable {
        width: 100%;
        text-align: left;
        padding-left: 16px;
    }

    #jobTable th,
    #jobTable td {
        text-align: left;
    }
</style>
